// Generated by Melange

import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Curry from "melange.js/curry.js";
import * as Js__Js_dict from "melange.js/js_dict.js";
import * as Mapre_web__Browser from "./browser.js";
import * as Mapre_web__Web_build_model from "./web_build_model.js";
import * as Mapre_web__Web_codec from "./web_codec.js";
import * as Mapre_web__Web_environment_codec from "./web_environment_codec.js";
import * as Mapre_web__Web_model from "./web_model.js";
import * as Mapre_web__Web_types from "./web_types.js";
import * as Mapre_wire__Json from "../../shared/wire/json.js";
import * as Stdlib from "melange/stdlib.js";
import * as Stdlib__Array from "melange/array.js";
import * as Stdlib__List from "melange/list.js";
import * as Stdlib__Option from "melange/option.js";

function interrupt(t) {
  t.generation = t.generation + 1 | 0;
  Mapre_web__Browser.abort(t.controller);
  t.controller = new AbortController();
  Stdlib__Option.iter(Mapre_web__Browser.cancel, t.poll);
  t.poll = undefined;
}

function cancel(t) {
  interrupt(t);
  t.templates_revision = t.templates_revision + 1 | 0;
  Stdlib__Option.iter(Mapre_web__Browser.abort, t.templates_controller);
  t.templates_controller = undefined;
}

function path(t) {
  const match = Curry._1(t.model, undefined).route;
  if (/* tag */ typeof match !== "object" && typeof match !== "function") {
    return Stdlib.invalid_arg("build_without_project");
  }
  switch (match.TAG) {
    case /* Project */ 2 :
    case /* Session */ 3 :
      break;
    default:
      return Stdlib.invalid_arg("build_without_project");
  }
  return "/api/workspaces/" + (match._0 + ("/projects/" + match._1));
}

function failed(t, error) {
  let tmp;
  tmp = /* tag */ typeof error !== "object" && typeof error !== "function" || error.TAG !== /* Failed */ 1 ? "Unable to access templates." : error._0;
  const action = {
    TAG: /* Failed */ 6,
    _0: tmp
  };
  Curry._1(t.emit, {
    TAG: /* Build */ 34,
    _0: action
  });
  if (/* tag */ typeof error !== "object" && typeof error !== "function" || error.TAG !== /* Failed */ 1) {
    return Curry._1(t.failure, error);
  }
  
}

function request(t, body, suffix, consume) {
  const generation = t.generation;
  Mapre_web__Browser.request(t.controller, undefined, body, path(t) + suffix).then(function (result) {
    if (generation === t.generation && Curry._1(t.model, undefined).build_form !== undefined) {
      if (result.TAG === /* Ok */ 0) {
        try {
          Curry._1(consume, result._0);
        }
        catch (raw_exn){
          const exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
          if (exn.MEL_EXN_ID === Mapre_wire__Json.Invalid) {
            failed(t, /* Invalid_response */ 2);
          } else {
            throw exn;
          }
        }
      } else {
        failed(t, result._0);
      }
    }
    return Promise.resolve();
  });
}

function same_project(t, base) {
  const match = Mapre_web__Web_types.project(Curry._1(t.model, undefined).route);
  if (match !== undefined) {
    return path(t) === base;
  } else {
    return false;
  }
}

function refresh_templates(t) {
  const match = Mapre_web__Web_types.project(Curry._1(t.model, undefined).route);
  if (match === undefined) {
    return;
  }
  const base = path(t);
  t.templates_revision = t.templates_revision + 1 | 0;
  Stdlib__Option.iter(Mapre_web__Browser.abort, t.templates_controller);
  const controller = new AbortController();
  t.templates_controller = Caml_option.some(controller);
  const revision = t.templates_revision;
  Mapre_web__Browser.request(controller, undefined, undefined, base + "/templates").then(function (result) {
    if (revision === t.templates_revision && !Mapre_web__Web_model.locked(Curry._1(t.model, undefined)) && same_project(t, base)) {
      if (result.TAG === /* Ok */ 0) {
        try {
          Curry._1(t.emit, {
            TAG: /* Templates */ 4,
            _0: Mapre_web__Web_codec.templates(result._0)
          });
        }
        catch (raw_exn){
          const exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
          if (exn.MEL_EXN_ID === Mapre_wire__Json.Invalid) {
            Curry._1(t.failure, /* Invalid_response */ 2);
          } else {
            throw exn;
          }
        }
      } else {
        const error = result._0;
        if (/* tag */ typeof error !== "object" && typeof error !== "function") {
          if (error === /* Unauthorized */ 0) {
            Curry._1(t.failure, error);
          }
          
        } else if (error.TAG === /* Missing */ 0) {
          Curry._1(t.failure, error);
        }
        
      }
    }
    return Promise.resolve();
  });
}

function refresh_builds(t) {
  Stdlib__Option.iter(Mapre_web__Browser.cancel, t.poll);
  t.poll = undefined;
  request(t, undefined, "/builds", (function (json) {
    const builds = Stdlib__List.map(Mapre_web__Web_build_model.decode, Stdlib__Array.to_list(Mapre_wire__Json.array(json, "builds")));
    Curry._1(t.emit, {
      TAG: /* Build */ 34,
      _0: {
        TAG: /* Builds */ 4,
        _0: builds
      }
    });
    refresh_templates(t);
    if (Stdlib__List.exists(Mapre_web__Web_build_model.active, builds)) {
      t.poll = setTimeout((function (param) {
        refresh_builds(t);
      }), 5000);
      return;
    }
    
  }));
}

function load(t) {
  cancel(t);
  Curry._1(t.emit, {
    TAG: /* Build */ 34,
    _0: /* Loading */ 3
  });
  request(t, undefined, "/environment", (function (json) {
    const receipt = Mapre_web__Web_environment_codec.receipt(json);
    Curry._1(t.emit, {
      TAG: /* Build */ 34,
      _0: {
        TAG: /* Environment */ 3,
        _0: receipt.project_version,
        _1: receipt.current_version
      }
    });
  }));
  refresh_builds(t);
}

function dispatch(t, action) {
  if (/* tag */ typeof action !== "object" && typeof action !== "function") {
    switch (action) {
      case /* Close */ 0 :
        interrupt(t);
        return Curry._1(t.emit, {
          TAG: /* Build */ 34,
          _0: /* Close */ 0
        });
      case /* Refresh */ 1 :
        if (Curry._1(t.model, undefined).build_form !== undefined) {
          return load(t);
        }
        break;
    }
  } else if (action.TAG === /* Open */ 0 && Mapre_web__Web_model.can_edit_environment(Curry._1(t.model, undefined))) {
    const action$1 = {
      TAG: /* Open */ 0,
      _0: crypto.randomUUID()
    };
    Curry._1(t.emit, {
      TAG: /* Build */ 34,
      _0: action$1
    });
    return load(t);
  }
  const form = Curry._1(t.model, undefined).build_form;
  if (form === undefined) {
    return;
  }
  if (form.pending) {
    return;
  }
  if (/* tag */ typeof action !== "object" && typeof action !== "function") {
    if (action === /* Submit */ 2) {
      if (!(Mapre_web__Web_model.can_manage_project(Curry._1(t.model, undefined)) && Mapre_web__Web_build_model.can_submit(form))) {
        return;
      }
      Curry._1(t.emit, {
        TAG: /* Build */ 34,
        _0: /* Pending */ 4
      });
      const body = JSON.stringify(Js__Js_dict.fromList({
        hd: [
          "request_id",
          Mapre_wire__Json.str(form.request_id)
        ],
        tl: {
          hd: [
            "expected_project_version",
            form.project_version
          ],
          tl: {
            hd: [
              "environment_version",
              form.environment_version
            ],
            tl: {
              hd: [
                "revision",
                null
              ],
              tl: {
                hd: [
                  "provider",
                  Mapre_wire__Json.str("boat")
                ],
                tl: {
                  hd: [
                    "size",
                    Mapre_wire__Json.str("small")
                  ],
                  tl: {
                    hd: [
                      "budget_microusd",
                      Stdlib__Option.get(Mapre_web__Web_build_model.money(form.budget))
                    ],
                    tl: /* [] */ 0
                  }
                }
              }
            }
          }
        }
      }));
      return request(t, body, "/builds", (function (json) {
        Mapre_web__Web_build_model.decode(Mapre_wire__Json.get(json, "build"));
        const action = {
          TAG: /* Accepted */ 5,
          _0: crypto.randomUUID()
        };
        Curry._1(t.emit, {
          TAG: /* Build */ 34,
          _0: action
        });
        refresh_builds(t);
      }));
    } else {
      return;
    }
  }
  if (action.TAG !== /* Budget */ 1) {
    return;
  }
  const action_0 = action._0;
  const action_1 = crypto.randomUUID();
  const action$2 = {
    TAG: /* Edited */ 2,
    _0: action_0,
    _1: action_1
  };
  Curry._1(t.emit, {
    TAG: /* Build */ 34,
    _0: action$2
  });
}

function create(emit, model, failure) {
  return {
    emit,
    model,
    failure,
    generation: 0,
    controller: new AbortController(),
    poll: undefined,
    templates_revision: 0,
    templates_controller: undefined
  };
}

export {
  create,
  cancel,
  refresh_templates,
  dispatch,
}
/* Mapre_web__Browser Not a pure module */
